module.exports = __webpack_public_path__ + "img/7.6ac2fd3d.jpg";